import { TPAComponentProps } from '../../types';

export interface BreadcrumbsItem {
  id: string | number;
  value: string;
  href: string;
}

export interface BreadcrumbsDefaultProps {
  showTrailOnMobileMode: boolean;
}

export interface BreadcrumbsProps extends TPAComponentProps {
  /**
   * The Breadcrumbs items. There should be at least 2 Breadcrumbs items.
   * {id: Specifies the item id (string | number),
   * value: Value to be shown on breadcrumb. (string),
   * href: the link for the page}
   */
  items: BreadcrumbsItem[];
  /**
   * Whether to show the full breadcrumbs trail or not. This prop is relevant only for mobile mode.
   */
  showTrailOnMobileMode?: boolean;
  /**
   * Click handler
   */
  onClick?(item: BreadcrumbsItem): any;
  /**
   * Defines a string value that labels the Breadcrumbs element. Optional.
   */
  'aria-label'?: string;
  /**
   * Identifies the element that labels the Breadcrumbs element. Optional.
   */
  'aria-labelledby'?: string;
}
